import React, { useEffect, useState } from 'react'
import useFetch from 'use-http'

import { Box, Button, Card, Heading, Inline, Modal, SelectField, Stack, TextField } from '@myxplor/stardust'

interface Props {
  account: Nullable<Papi.Account>
  isOpen: boolean
  vendors: Papi.Vendor[]
  onCancel(): void
  onSave(account: Papi.Account): void
}

const AccountModal = ({ account, isOpen, vendors, onCancel, onSave }: Props) => {
  const [accountModel, setAccountModel] = useState<Nullable<Record<string, any>>>(null)

  const accountRequest = useFetch('/api/v1/accounts')

  const onChange = (field: string, value: number | string) => {
    setAccountModel((model: any) => ({ ...model, [field]: value }))
  }

  const handleSave = async () => {
    if (accountModel) {
      const response = await accountRequest.post(accountModel)

      onSave(response.data)
    }
  }

  useEffect(() => setAccountModel(account || {}), [account])

  if (!accountModel) {
    return null
  }

  const vendorMap = vendors.reduce((acc, vendor) => {
    return { ...acc, [vendor.id]: vendor.name }
  }, {})

  return (
    <Modal backdrop isOpen={isOpen} onBlur={onCancel}>
      <Card>
        <Box minWidth={600} padding="small">
          <Stack space="small">
            <Heading level={5}>Account</Heading>
            <SelectField
              defaultValue={accountModel.vendor_id}
              label="Vendor"
              items={vendorMap}
              required
              onSelect={(value) => onChange('vendor_id', value)}
            />
            <TextField
              label="Name"
              name="name"
              placeholder="Display name for this account"
              required
              value={accountModel.name || ''}
              onChange={(value) => onChange('name', value)}
            />
            <TextField
              label="Username"
              name="username"
              placeholder="Username the account will use to make API requests"
              required
              value={accountModel.username || ''}
              onChange={(value) => onChange('username', value)}
            />
            <TextField
              label="Tenant"
              name="tenant_id"
              placeholder="The tenant ID for the account, for example the QK DBID"
              value={accountModel.tenant_id || ''}
              onChange={(value) => onChange('tenant_id', value)}
            />
            <Inline align="right" space="small">
              <Button variant="outline" onClick={onCancel}>
                Cancel
              </Button>
              <Button onClick={handleSave}>Save</Button>
            </Inline>
          </Stack>
        </Box>
      </Card>
    </Modal>
  )
}

export default React.memo(AccountModal)
